import { BADGE_CONFIG } from "@/components/layout/DealStatusBadge";

// The same tinted pill as a funded application's status.
const COLOR = BADGE_CONFIG.funded.color;

export function LinkedPill() {
  return (
    <span
      className="inline-flex items-center whitespace-nowrap rounded-full px-2.5 py-0.5 text-[11px] font-semibold tracking-wide"
      style={{ backgroundColor: `${COLOR}18`, color: COLOR, border: `1px solid ${COLOR}38` }}
    >
      Linked
    </span>
  );
}
